import { Injectable } from "@angular/core";

/**
 * Data Access Object for the first time user uses the application.
 */
@Injectable({
  providedIn: "root",
})
export class IsFirstTimeDao {
  private readonly IS_FIRST_TIME_KEY = "is-first-time";

  /**
   * When the user logs in for the first time, the following function will
   * be executed to save a key in the local storage.
   * This will help us determine whether or not the user is using the
   * application for the first time.
   * @param isFirstTime
   */
  setIsFirstTime(isFirstTime: boolean) {
    window.localStorage.setItem(
      this.IS_FIRST_TIME_KEY,
      JSON.stringify(isFirstTime)
    );
  }
  /**
   * This method is used to determine if the user is using the application for the first time,
   * and if so, redirect them to the onboarding component. To achieve this,
   * a key is stored in the local storage when the user first accesses the application.
   * Then, each time the user logs in, this method is executed to check if the key exists in the local storage.
   * @return will return true if it is not the first time the user uses the aplication.
   */
  getIsFirstTime(): boolean {
    const isFirstTime = window.localStorage.getItem(this.IS_FIRST_TIME_KEY);
    return isFirstTime === null;
  }
}
